import { Route, Routes } from "react-router-dom";
import PrivateRoute from "./privateRoute";
import MasterLayout from "../layout";
import { Company, FirstLogin, Lock, Login, Role, User } from "../pages/auth";
import Home from "../pages/home";
import {
  Almanac,
  Dictionary,
  DictionaryItem,
} from "../pages/config";
import { useInactivityLogout } from "../utils";
import { Errors404 } from "../pages/error";
import { Student } from "../pages/app";

export default function Routers() {
  const logoutTime = 5 * 60 * 1000;

  useInactivityLogout(logoutTime);

  return (
    <>
      <Routes>
        <Route exact path="/" element={<Login />} />
        <Route exact path="/lockscreen" element={<Lock />} />
        <Route exact path="/firstlogin" element={<FirstLogin />} />
        <Route path="*" element={<Errors404 />} />
        <Route element={<MasterLayout />}>
          <Route
            exact
            path="/home"
            element={
              <PrivateRoute>
                <Home />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/user"
            element={
              <PrivateRoute>
                <User />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/role"
            element={
              <PrivateRoute>
                <Role />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/dictionary"
            element={
              <PrivateRoute>
                <Dictionary />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/dictionary-item"
            element={
              <PrivateRoute>
                <DictionaryItem />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/almanac"
            element={
              <PrivateRoute>
                <Almanac />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/academic"
            element={
              <PrivateRoute>
                <Almanac />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/student"
            element={
              <PrivateRoute>
                <Student />
              </PrivateRoute>
            }
          />
        </Route>
      </Routes>
    </>
  );
}
